module.exports = __webpack_public_path__ + "img/emoji_20.19f516ba.png";